import { AppSetting } from '../AppSetting';
import { BaseWebApiDAO } from './BaseWebApiDAO';
import { BaseService } from '../Service/BaseService';
import { AppSettingApi } from '../AppSettingApi';



/**
 * AuthDAO
 * 認証系DAO
 */
export class AuthDAO extends BaseWebApiDAO {

	// コンストラクタ
	constructor(svc: BaseService) {
		super(svc);
	}


	/**
	 * login
	 * メールアドレス/パスワードログイン
	 * @param mail メールアドレス
	 * @param password パスワード
	 * @returns トークン
	 */
	public async login(mail: string, password: string) {
		// リクエスト作成
		// ここでいうユーザーIDはログインで使うもの。サーバー側でログインコードと言う名前で扱っているので
		// リクエストキーの名前を合わせておく
		const request = {
			email: mail,
			password
		};

		// リクエスト実行。エラーは中で用意される。
		// TODO: API変更
		const ret = await this.postRequest(AppSettingApi.AUTH_LOGIN, request);
		return ret;

	}

	/**
	 * getConfigForClient
	 * Lineログインの設定取得
	 * @returns
	 */
	public async getConfigForClient() {
		return await this.postRequest(AppSettingApi.AUTH_LOGIN_LINE_AUTH_CONFIG, {});
	}

	/**
	 * lineLoginRecordAuth
	 * Lineへの認可コード取得依頼を記録する
	 * @returns
	 */
	public async lineLoginRecordAuth(loginUrl: string, stateString: string, nonceString: string) {

		// リクエスト作成
		const request = {
			url: loginUrl,
			state: stateString,
			nonce: nonceString
		};

		return await this.postRequest(AppSettingApi.AUTH_LOGIN_LINE_RECORD_AUTH, request);
	}

	/**
	 * lineLoginRecordAuthCallBack
	 * Lineへの認可コード取得依頼のコールバックを記録する
	 * @returns
	 */
	public async lineLoginRecordAuthCallBack(url: string, authCode: string, stateString: string, errorCode: string, errorDescription: string) {

		// リクエスト作成
		const request = {
			url,
			code: authCode,
			state: stateString,
			lineErrorCode: errorCode,
			lineErrorDescription: errorDescription,
		};

		return await this.postRequest(AppSettingApi.AUTH_LOGIN_LINE_RECORD_AUTH_CALLBACK, request);
	}

	/**
	 * lineLogin
	 *
	 * Lineにユーザー情報の取得を依頼する
	 * @returns トークン
	 */
	public async lineLogin(authCode: string, nonceString: string, token: string) {
		// リクエスト作成
		const request = {
			code: authCode,
			nonce: nonceString,
			tokenCheck: token
		};

		return await this.postRequest(AppSettingApi.AUTH_LOGIN_LINE, request);
	}

	/**
	 * sendForgetPassword
	 * パスワード忘れメール送信
	 * @param mail メールアドレス
	 */
	public async sendForgetPassword(mail: string, birthday: any) {

		// リクエスト作成
		const request = {
			email: mail,
			birthday
		};

		// リクエスト実行。エラーは中で用意される。
		const ret = await this.postRequest(AppSettingApi.AUTH_LOGIN_FORGET_PASSWORD, request);
		return ret;

	}

	/**
	 * sendForgetPasswordInLogin
	 * パスワード忘れメール送信
	 * @param birthday 生年月日
	 */
	public async sendForgetPasswordInLogin(birthday: string) {
		// リクエスト作成
		const request = {
			t: this.token,
			birthday
		};

		// リクエスト実行。エラーは中で用意される。
		const ret = await this.postRequest(AppSettingApi.AUTH_LOGIN_FORGET_PASSWORD_INLOGIN, request);
		return ret;

	}

	/**
	 * resettingPassword
	 * パスワード再設定
	 * @param token リセットトークン
	 * @param password パスワード
	 * @returns 成功可否
	 */
	public async resettingPassword(token: string, password: string) {
		// リクエスト作成
		const request = {
			t: token,
			password
		};

		// リクエスト実行。エラーは中で用意される。
		const ret = await this.postRequest(AppSettingApi.AUTH_LOGIN_RESET_PASSWORD, request);
		return ret;

	}

	/**
	 * changeUserPassword
	 * パスワード変更
	 * @param oldPass 現在のパスワード
	 * @param newPass 新しいパスワード
	 * @returns ユーザー情報
	 */
	public async changeUserPassword(oldPass: string, newPass: string) {

		// デバッグモードならダミーを返す
		if ( AppSetting.DEBUG_MODE_DUMYDATA ) {
			return '';
		}

		// リクエスト作成
		const request = {
			t: this.token,
			current_password: oldPass,
			new_password: newPass
		};

		// リクエスト実行。エラーは中で用意される。
		const ret = await this.postRequest(AppSettingApi.AUTH_CHANGE_PASSWORD, request);
		return ret;

	}

	/**
	 * createPassword
	 * @param password
	 */
	public async createPassword(password: string) {

		// デバッグモードならダミーを返す
		if ( AppSetting.DEBUG_MODE_DUMYDATA ) {
			return '';
		}

		// リクエスト作成
		const request = {
			t: this.token,
			password,
		};

		// リクエスト実行。エラーは中で用意される。
		const ret = await this.postRequest(AppSettingApi.AUTH_CREATE_PASSWORD, request);
		return ret;

	}

	/**
	 * パスワードの存在チェック
	 */
	public async isExistPassword() {

		// リクエスト作成
		const request = {
			t: this.token,
		};

		// リクエスト実行。エラーは中で用意される。
		const ret = await this.postRequest(AppSettingApi.AUTH_EXIST_PASSWORD, request);
		return ret;

	}


}

/**
 * このDAOで使うレスポンスモデル
 */
export class ResponseToken {
	// パラメータ
	public t: string; // トークン

	/**
	 * constructor
	 * @param data トークン
	 */
	constructor( data: any){
		this.t = data;
	}
}


